import { Box, Divider } from '@chakra-ui/react';

export const GA4ToMMMContent = () => (
  <Box>
    <Box
      as="h2"
      fontSize="24px"
      fontWeight="bold"
      color="text.darkBlue.900"
      mb={4}
      mt={8}
      fontFamily="marketingPage">
      Introduction: From Traffic Jams to Greenlight Insight
    </Box>
    <Box mb={4}>
      In today&apos;s fast-paced marketing world,{' '}
      <Box as="span" fontStyle="italic">
        insights delayed are opportunities lost
      </Box>
      . What if you could turn your GA4 setup into a full-blown, ML-driven
      Marketing Mix Model in under 90 minutes? Merkatus.io makes that an
      AI-powered, warehouse-native, and instantly actionable reality.
    </Box>
    <Divider my={12} />
    <Box mb={4}>
      <Box
        as="h2"
        fontSize="24px"
        fontWeight="bold"
        color="text.darkBlue.900"
        mb={4}
        mt={8}
        fontFamily="marketingPage">
        Step 1: GA4 + Merkatus.io = Instant Readiness
      </Box>
      <Box mb={4}>
        Google&apos;s GA4 provides{' '}
        <Box as="span" fontWeight="bold">
          Enhanced Ecommerce
        </Box>{' '}
        that allows you to track sales in an online store and have data
        available. Merkatus.io plugs directly into that pipeline, creating a
        seamless flow: as soon as your GA4 data lands on our platform,
        Merkatus.io starts modeling automatically, no ETL gymnastics needed.
      </Box>
      <Box mb={4}>
        That&apos;s the &apos;from data chaos to decisions, fast&apos; promise.
      </Box>
    </Box>
    <Divider my={12} />
    <Box mb={4}>
      <Box
        as="h2"
        fontSize="24px"
        fontWeight="bold"
        color="text.darkBlue.900"
        mb={4}
        mt={8}
        fontFamily="marketingPage">
        Step 2: Build Your Media Mix in Minutes
      </Box>
      <Box mb={4}>
        With GA4 and any other ad platforms (Google Ads, Meta, etc.) linked
        through the Merkatus platform, Merkatus.io immediately aligns and
        standardizes spend and outcome data. There&apos;s no need to wrangle
        with schemas, as Merkatus.io normalizes everything under the hood.
      </Box>
    </Box>
    <Divider my={12} />
    <Box mb={4}>
      <Box
        as="h2"
        fontSize="24px"
        fontWeight="bold"
        color="text.darkBlue.900"
        mb={4}
        mt={8}
        fontFamily="marketingPage">
        Step 3: Leverage AI for Rapid Modeling
      </Box>
      <Box mb={4}>
        Using AI-powered modeling, Merkatus.io transforms your marketing inputs
        into fully baked MMM outputs, response curves, channel ROI, and
        optimization scenarios, often within your very first session. Think of
        it as AI plus your warehouse data, feeding you insights that guide
        decisions in real time.
      </Box>
    </Box>
    <Divider my={12} />
    <Box mb={4}>
      <Box
        as="h2"
        fontSize="24px"
        fontWeight="bold"
        color="text.darkBlue.900"
        mb={4}
        mt={8}
        fontFamily="marketingPage">
        Step 4: Visualize & Plan in the Merkatus.io platform
      </Box>
      <Box mb={4}>
        Merkatus.io pipes results into dashboards and views inside its platform,
        that lets you run &quot;what-if&quot; budgets with Merkatus.io&apos;s
        scenario tool and see the ROI impact live. This integration is part of
        our design ethos: use what you have, get what you need.
      </Box>
    </Box>
    <Divider my={12} />
    <Box mb={4}>
      <Box
        as="h2"
        fontSize="24px"
        fontWeight="bold"
        color="text.darkBlue.900"
        mb={4}
        mt={8}
        fontFamily="marketingPage">
        Step 5: Set It, Refresh, Repeat
      </Box>
      <Box mb={4}>
        Once set up, your MMM can refresh weekly – or even daily – keeping up
        with market shifts without replatforming or scripting. That&apos;s
        continuous, always-on modeling powered by the existing infrastructure,
        augmented with AI.
      </Box>
    </Box>
    <Divider my={12} />
    <Box mb={4}>
      <Box
        as="h2"
        fontSize="24px"
        fontWeight="bold"
        color="text.darkBlue.900"
        mb={4}
        mt={8}
        fontFamily="marketingPage">
        Conclusion: From Raw Data to Smart Decisions
      </Box>
      <Box mb={4}>
        With GA4 events and Merkatus.io at your side, you can go from raw data
        to ROI insights in{' '}
        <Box as="span" fontStyle="italic">
          under 90 minutes
        </Box>
        . Fast, accurate, and ready for action.
      </Box>
    </Box>
  </Box>
);
